import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddressRepository } from '@/core/domain/address/repositories/address.repository';
import { AddressImplRepository } from './address-imp.respository';
import { GetCountriesUseCase } from '@/core/domain/address/usecases/getCountries.usecase';
import { GetStatesUseCase } from '@/core/domain/address/usecases/getSates.usecase';
import { GetCitiesUseCase } from '@/core/domain/address/usecases/getCities.usecase';
import { GetNeighborhoodsUseCase } from '@/core/domain/address/usecases/getNeighborhoods.usecase';

const getCountriesUseCaseFactory = (addressRepository: AddressRepository) =>
    new GetCountriesUseCase(addressRepository);

const getStatesUseCaseFactory = (addressRepository: AddressRepository) =>
    new GetStatesUseCase(addressRepository);

const getCitiesUseCaseFactory = (addressRepository: AddressRepository) =>
    new GetCitiesUseCase(addressRepository);

const getNeighborhoodsUseCaseFactory = (addressRepository: AddressRepository) =>
    new GetNeighborhoodsUseCase(addressRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetNeighborhoodsUseCase,
            useFactory: getNeighborhoodsUseCaseFactory,
            deps: [AddressImplRepository],
        },
        {
            provide: GetCitiesUseCase,
            useFactory: getCitiesUseCaseFactory,
            deps: [AddressImplRepository],
        },
        {
            provide: GetStatesUseCase,
            useFactory: getStatesUseCaseFactory,
            deps: [AddressImplRepository],
        },
        {
            provide: GetCountriesUseCase,
            useFactory: getCountriesUseCaseFactory,
            deps: [AddressImplRepository],
        },
        {
            provide: AddressRepository,
            useClass: AddressImplRepository,
        },
    ],
})
export class AddressDataModule {}
